// src/components/songEdit/components/BasicSongInfo.tsx
import React from 'react';

interface BasicSongInfoProps {
  title: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const BasicSongInfo: React.FC<BasicSongInfoProps> = ({ title, onChange }) => (
  <div className="song-form__group">
    <label className="song-form__label">Title *</label>
    <input
      type="text"
      className="song-form__input form-control"
      name="title"
      value={title}
      onChange={onChange}
      required
      // Remove any disabled or readOnly props if they exist
    />
  </div>
);